jQuery(function($) {

  var activateSearch = function() {
    $('body').addClass('search-active');
    $('body').removeClass('menu-active');
    var winWidth = $(window).width();
    if (winWidth >= 1042) {
      $('.search__form .search__input').focus();
    }
    else {
      $('.header__search__form .search__input').focus();
    }
  }

  var deactivateSearch = function() {
    $('body').removeClass('search-active');
  }

  var toggleSearch = function() {
    if ($('body').hasClass('search-active')) {
      deactivateSearch();
    }
    else {
      activateSearch();
    }
  }

  $('.toggle-search').on('click', function() {
    toggleSearch();
  });






  $(window).on('load resize', function() {
    var headerHeight = $('header').outerHeight();
    $('.header__search__form').css('top', headerHeight + 'px');
  });

});
